import type { SiteCategory } from 'types/common/SiteCategory';
import { PurchaseType } from 'types/product/PurchaseType';

// Returns the purchaseType the visible PDP renders with. Skincare PDPs are
// currently forced to one-time-purchase mode - Shopify selling plans may
// exist on the variant, but the configurator doesn't expose them.
//
// Keep this aligned with `components/pages/Product.tsx` which threads the
// same purchaseType into `ProductConfiguratorRender`.
export const getPdpPurchaseType = (
  category: SiteCategory | undefined,
): PurchaseType | undefined =>
  category === 'skincare' ? PurchaseType.OTP : undefined;
